export default function devLog(...args) {
    // function that performs a console.log only if the environment is development
    if (process.env.REACT_APP_DEPLOYED_BOOLEAN === 'false' ||
        process.env.REACT_APP_PRODUCTION_URL == 'https://legalpulse-dev.vercel.app') {
        console.log(...args);
    }
}